/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
import { PageIcon } from '@/types';
import FabricCanvasExercise, { Props } from '../fabricexercise';
import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric';
const paths = {
  check:
    'M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z',
  times:
    'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z',
  minus:
    'M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z',
  size: 512,
};
const fabricPaths = {
  check: new fabric.Path(paths.check).path,
  times: new fabric.Path(paths.times).path,
  minus: new fabric.Path(paths.minus).path,
};
const colors = {
  true: 'green',
  wrong: 'red',
  empty: '#ff9f43',
  notKnown: 'gray',
};
const setAsTrue = (item: any) => {
  item.set('fill', colors.true);
  item.set('path', fabricPaths.check);
};
const setAsEmpty = (item: any) => {
  item.set('fill', colors.empty);
  item.set('path', fabricPaths.minus);
};
const setAsNotKnown = (item: any) => {
  item.set('fill', colors.notKnown);
  item.set('path', fabricPaths.check);
};
const setAsWrong = (item: any) => {
  item.set('fill', colors.wrong);
  item.set('path', fabricPaths.times);
};
class Tick extends FabricCanvasExercise {
  private options: PageIcon[] = []; // Kaynak veriler

  configureCanvas(props: Props) {
    const canvas = this._canvas;
    const parentThis = this;
    const sources = [];
    if(props.currentPageItem.sources){
      this.options= props.currentPageItem.sources;
    }
    const hasCompleteButton = props.currentPageItem.hasCompleteButton;
    let index = 0;
    const backgroundCoordinate = canvas.getBackgroundImageCoordinate();
    for (const option of  this.options) {
      const left =backgroundCoordinate.imgLeft + option.x;
      const top =backgroundCoordinate.imgTop + option.y;
      const radius =
        (option.width < option.height
          ? option.width / 2
          : option.height / 2);
      const scale =
        Math.min(
          option.width / paths.size,
          option.height / paths.size,
        )
        const s = new fabric.Circle({
          strokeWidth: 2,
          opacity: 1,
          stroke: 'darkblue',
          strokeDashArray: [2, 2],
          radius,
          fill: '',
          left,
          top,
          id: `source-${index}`,
          name: `source-${index}`,
          index,
          erasable: false,
          selectable: false,
          hasControls: false,
          hasBorders: false,
          pageIcon: true,
          isCorrect: option.isCorrect,
          isChecked: false,
          optionId: option.id,
          hoverCursor: 'pointer',
          checkIcon: new fabric.Path(paths.check, {
            fill: colors.notKnown,
            selectable: false,
            id: `check-${option.id}`,
            left: left + 1.5,
            top: top + 1.5,
            scaleX: scale,
            scaleY: scale,
            erasable: false,
            pageIcon: true,
            sourceId: option.id,
            hoverCursor: 'pointer',
          }),
        });
        sources.push(s);
        canvas.addObject(s);
      index++;
    }
    sources.forEach(function (source) {
      source.on('mousedown:before', (o: any) => {
        canvas.closeDrawingMode();
      });

      source.on('mousedown', function () {
        if (!source.isChecked) {
          source.set('isChecked', true);
          canvas.addObject(source.checkIcon);
          if (hasCompleteButton) {
            setAsNotKnown(source.checkIcon);
          } else {
            parentThis.playSound(source.isCorrect);
            if (source.isCorrect) {
              setAsTrue(source.checkIcon);
            } else {
              setAsWrong(source.checkIcon);
            }
            parentThis.addOpenedAnswers(source.optionId);
          }
          fabric.util.animate({
            startValue: 0,
            endValue: 1,
            duration: 200,
            onChange(value: any) {
              source.checkIcon.set('opacity', value);
              canvas.sendToBack(source.checkIcon);
              canvas.canvasRenderAll();
            },
            onComplete() {},
          });
        } else {
          source.set('isChecked', false);
          parentThis.removeOpenedAnswers(source.optionId);
          const objects = canvas.getObjects();
          objects.forEach((o) => {
            if (o.id === `check-${source.optionId}`) {
              fabric.util.animate({
                startValue: 1,
                endValue: 0,
                duration: 200,
                onChange(value: any) {
                  o.set('opacity', value);
                  canvas.canvasRenderAll();
                },
                onComplete() {
                  canvas.removeObject(o);
                  canvas.canvasRenderAll();
                },
              });
            }
          });
        }
      });
      source.on('mouseup', function () {
        canvas.openDrawingMode();
      });
    });
    // this.renderActivityFiles(props, opts);
  }
  onReset = () => {
    this.resetOpenedAnswers();
    const canvas = this._canvas;
    const allItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('source'));
    for (const item of allItems) {
      item.set('isChecked', false);
    }
    const checkItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('check'));
    for (const item of checkItems) {
      canvas.removeObject(item);
    }
    canvas.canvasRenderAll();
  };
  onShowAnswer = async () => {
    this.onReset();
    const canvas = this._canvas;
    const allItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('source'));
    for (const source of allItems) {
      if (source.isCorrect) {
        canvas.addObject(source.checkIcon);
        setAsTrue(source.checkIcon);
      } else {
        canvas.addObject(source.checkIcon);
        setAsWrong(source.checkIcon);
      }
      this.addOpenedAnswers(source.optionId);
    }
    this.playSound('solve');
    canvas.canvasRenderAll();
  };
  onComplete() {
    const canvas = this._canvas;
    const checkedItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('check'));
    const allItems = canvas
      .getObjects()
      .filter((x) => x.id && x.id.includes('source'));
    for (const item of allItems) {
      const checked = checkedItems.filter((e) => e.sourceId === item.optionId);
      if (item.isCorrect) {
        if (checked.length > 0) {
          setAsTrue(checked[0]);
        } else {
          canvas.addObject(item.checkIcon);
          setAsEmpty(item.checkIcon);
        }
      } else {
        if (checked.length > 0) {
          setAsWrong(checked[0]);
        }
      }
    }
    canvas.canvasRenderAll();
  }
  onShowPreviousAnswer = async () => {
    const canvas = this._canvas;
    const showedItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id &&
          x.id.includes('source') &&
          this.getOpenedAnswers().includes(x.optionId),
      );
    if (showedItems.length > 0) {
      const item = showedItems[showedItems.length - 1];
      item.set('isChecked', false);
      canvas.removeObject(item.checkIcon);
      this.removeOpenedAnswers(item.optionId);
      canvas.canvasRenderAll();
    }
  };
  onShowNextAnswer = async () => {
    const canvas = this._canvas;
    const notShowedItems = canvas
      .getObjects()
      .filter(
        (x) =>
          x.id &&
          x.id.includes('source') &&
          !this.getOpenedAnswers().includes(x.optionId),
      );
    if (notShowedItems.length > 0) {
      const item = notShowedItems[0];
      canvas.addObject(item.checkIcon);
      this.playSound(item.isCorrect);
      if (item.isCorrect) {
        setAsTrue(item.checkIcon);
      } else {
        setAsWrong(item.checkIcon);
      }
      this.addOpenedAnswers(item.optionId);
      canvas.canvasRenderAll();
    }
  };
  destroy() {
    this.resetOpenedAnswers();
  }
  doMouseDown(o: any) {}

  doMouseMove(o: any) {}

  doMouseUp(o: any) {}
}

export default Tick;
